import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  IDeleteTemplateCredentials,
  IRenameTemplateCredentials,
  ITemplateCheckNameCredentials,
  TemplatesCredentials,
  TemplatesResponse,
} from "@/modules/template/common/types";
import { generateQuery } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const templateApi = createApi({
  reducerPath: "templateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getTemplates: builder.query<TemplatesResponse, TemplatesCredentials>({
      query: ({ pageIndex, pageSize, transactionType, name }) => {
        const query = generateQuery({
          pageIndex,
          pageSize,
          transactionType,
          name,
        });
        const url = `${TemplateApiUrls.Templates}?${query}`;
        return { url };
      },
    }),
    deleteTemplate: builder.query<void, IDeleteTemplateCredentials>({
      query: ({ id }) => {
        const url = `${TemplateApiUrls.Templates}/${id}`;
        return { url, method: "DELETE" };
      },
    }),
    renameTemplate: builder.mutation<void, IRenameTemplateCredentials>({
      query: ({ id, name }) => {
        const url = `${TemplateApiUrls.Templates}/${id}/Rename`;
        return {
          url,
          method: "PATCH",
          data: { name }
        };
      }
    }),
    checkName: builder.query<boolean, ITemplateCheckNameCredentials>({
      query: ({ name }) => {
        const url = `${TemplateApiUrls.CheckName}?name=${name}`;
        return { url };
      },
    }),
  }),
});

export const {
  useLazyCheckNameQuery,
  useGetTemplatesQuery,
  useLazyDeleteTemplateQuery,
  useRenameTemplateMutation,
} = templateApi;
